import { cloneDeep, isEmpty } from "lodash";
import reduxStore from "../../configureEnvStore";
import { CALL_DATA } from "../../constants/PublicVariables";
import {
    setIsAnyVideoAvailableInTheRoom,
    setIsOpponentUserScreenSharing,
    setScreenSharingUsers,
    setStreamingDetails,
    setStreamingPartiIdentity,
    setVideoStreamingUsers,
} from "../../reducers/twilioEvents-reducer";
import { dualStreamEnabled } from "../../shared/utility";
import { getUserDetailsById, setStreamingPartiDetails } from "../Twilio/Room/roomFunction";
import { setGalleryViewConnectedUser } from "../../reducers/gallery-view-reducer";
import { manageScreenShareinMultiStream } from "../GalleryView/GalleryViewUtils";

// Function to update current streaming user details in Redux state
export const updateCurrentStreamingUserDetailsToRedux = (identity) => {
    if (dualStreamEnabled()) {
        return;
    }
    setStreamingPartiDetails(identity); // Streaming user set
    reduxStore.dispatch(setStreamingPartiIdentity(identity)); // Set streaming user identity
};

// Update redux state
const updateReduxState = (screenSharingUsersArray, videoStreamingUsersArray) => {
    updateStreamingDetailsToRedux(screenSharingUsersArray, videoStreamingUsersArray);
};

// Updating Redux States Based on updated screenSharingUsersArray & videoStreamingUsers Array
const updateStreamingDetailsToRedux = (screenSharingUsersArray, videoStreamingUsersArray) => {
    const { streamingDetails, streamingPartiIdentity, isAnyVideoAvailableInTheRoom } = reduxStore.getState().twilioEvents;

    // Updating state with the modified lists
    reduxStore.dispatch(setVideoStreamingUsers(videoStreamingUsersArray)); // set video streaming array
    reduxStore.dispatch(setScreenSharingUsers(screenSharingUsersArray)); // set screen share streaming array
    if (isEmpty(screenSharingUsersArray) && isEmpty(videoStreamingUsersArray)) {
        if (!isEmpty(streamingDetails)) {
            reduxStore.dispatch(setStreamingDetails({})); // Set streaming user identity
        }
        if (!isEmpty(streamingPartiIdentity)) {
            reduxStore.dispatch(setStreamingPartiIdentity(null)); // Set streaming user identity
        }
        if (isAnyVideoAvailableInTheRoom) {
            reduxStore.dispatch(setIsAnyVideoAvailableInTheRoom(false)); // for UI viewing purpose variable
        }
    }

    // Checking if any opponent user is sharing screen
    const remoteScreenSharingUsers = screenSharingUsersArray.filter((userSessionId) => userSessionId !== CALL_DATA.participantIdentity);
    reduxStore.dispatch(setIsOpponentUserScreenSharing(remoteScreenSharingUsers.length > 0));
};

// Handle video streaming overrides
const handleVideoStreamingOverrides = (updateEventUserSessionID, videoStreamingUsersArray, screenSharingUsersArray, isCurrentUserLocal) => {
    let hasOverwrittenStream = false;
    /*
        - in update event track, video is just subscribe (local and remote both)
        - check local user screenshre is already started
        - local screen stop, remove local user session ID from the screenshare array
    */
    if (screenSharingUsersArray.includes(CALL_DATA.participantIdentity)) {
        /* if local and remote user screenshare is already started, and any user start video then it should only stop started video user' screenshare */
        if (
            !dualStreamEnabled() ||
            (dualStreamEnabled() &&
                screenSharingUsersArray.includes(updateEventUserSessionID) &&
                updateEventUserSessionID == CALL_DATA.participantIdentity)
        ) {
            //// hasOverwrittenStream = true;
            //// stopScreenShare();
            //// screenSharingUsersArray = screenSharingUsersArray.filter((userSessionId) => userSessionId !== CALL_DATA.participantIdentity);
            console.log(":::hasOverwrittenStream:");
        }
    }

    const otherVideoStreamingUsersArray = videoStreamingUsersArray.filter((userSessionId) => userSessionId !== updateEventUserSessionID);

    /*
        - if remote user's video is just subscribe and local user video already started
        - check local user video is already started
        - local video stop, remove local user session ID from the video streaming array
    */
    if (otherVideoStreamingUsersArray.includes(CALL_DATA.participantIdentity) && !dualStreamEnabled()) {
        /* for multi stream local and remote user's video allows (do not override video) */
        //// hasOverwrittenStream = true;
        //// performStartStopVideo();
        videoStreamingUsersArray = videoStreamingUsersArray.filter((userSessionId) => userSessionId !== CALL_DATA.participantIdentity);
    }

    /*
        - Updating video streaming users array, if the update event's user session ID is not in the video streaming array
        - update redux's streaming details and video streaming user array
    */
    if (!videoStreamingUsersArray.includes(updateEventUserSessionID)) {
        videoStreamingUsersArray.push(updateEventUserSessionID);
        updateCurrentStreamingUserDetailsToRedux(updateEventUserSessionID);
    }

    return { videoStreamingUsersArray, screenSharingUsersArray, hasOverwrittenStream };
};

// Handle screen sharing overrides
const handleScreenSharingOverrides = (updateEventUserSessionID, videoStreamingUsersArray, screenSharingUsersArray, isCurrentUserLocal) => {
    /*
        - in update event track is screen share is just subscribe/started (local and remote both)
        - check local user video is already started
        - local video stop, remove local user session ID from the video array
    */
    if (videoStreamingUsersArray.includes(CALL_DATA.participantIdentity) && !dualStreamEnabled()) {
        /* for multi stream local and remote user's video and screenshare allows (do not override with video/screenshare) */
        //// performStartStopVideo();
        //// videoStreamingUsersArray = videoStreamingUsersArray.filter((userSessionId) => userSessionId !== CALL_DATA.participantIdentity);
    }

    // if local audio, and video is start and audio going to stop then this line of code with help to not stop the local video
    const otherScreenSharingUsers = screenSharingUsersArray.filter((userSessionId) => userSessionId !== updateEventUserSessionID);

    /*
        - if remote user's screenshare is just subscribe/start
        - check local user screenshare is already started
        - local screenshare stop, remove local user session ID from the screenshare streaming array
    */
    if (otherScreenSharingUsers.includes(CALL_DATA.participantIdentity) && !dualStreamEnabled()) {
        /* for multi stream local and remote user's video and screenshare allows (do not override with video/screenshare) */
        //// stopScreenShare(false);
        screenSharingUsersArray = screenSharingUsersArray.filter((userSessionId) => userSessionId !== CALL_DATA.participantIdentity);
    }

    /*
        - Updating screenshare streaming users array, if the update event's user session ID is not in the screenshare streaming array
        - update redux's streaming details and screenshare streaming user array
    */
    if (!screenSharingUsersArray.includes(updateEventUserSessionID)) {
        screenSharingUsersArray.push(updateEventUserSessionID);
        updateCurrentStreamingUserDetailsToRedux(updateEventUserSessionID);
        if (dualStreamEnabled()) {
            // agent automatic expand screenshare and send the data track to other user
            setTimeout(() => {
                const participant = updateEventUserSessionID;
                manageScreenShareinMultiStream(participant); //send expand msg after track published
            }, 1000);
        }
    }

    return { videoStreamingUsersArray, screenSharingUsersArray };
};

// Main function
export const updateStreamingStatusOnEvent = (isVideo, identity, isScreenShare, isLocal) => {
    const { videoStreamingUsers: reduxVideoStreamingUsers, screenSharingUsers: reduxScreenSharingUsers } = reduxStore.getState().twilioEvents;

    let videoStreamingUsersArray = [...reduxVideoStreamingUsers]; // video streaming user array
    let screenSharingUsersArray = [...reduxScreenSharingUsers]; // screen share streaming user array
    let hasOverwrittenStream = false; // check video and screenshare override variable

    const updateEventUserSessionID = identity; // update event user's session ID
    const isCurrentUserLocal = isLocal; // update event user's is local user or not

    const isVideoGoingToStream = isVideo; // check track status of video
    const isScreenShareGoingToStream = isScreenShare; // check track status of screenshare

    if (dualStreamEnabled()) {
        setVideoScreenShareInGrid(updateEventUserSessionID, isVideoGoingToStream, isScreenShareGoingToStream);
    }

    if (isVideoGoingToStream) {
        // update event user's track is video true (isVideoStreaming)
        const result = handleVideoStreamingOverrides(updateEventUserSessionID, videoStreamingUsersArray, screenSharingUsersArray, isCurrentUserLocal);
        videoStreamingUsersArray = result.videoStreamingUsersArray; // set updated user's video streaming array
        screenSharingUsersArray = result.screenSharingUsersArray; // set updated user's screenshare streaming array
        hasOverwrittenStream = result.hasOverwrittenStream; // set override value true or false
    } else if (videoStreamingUsersArray.includes(updateEventUserSessionID) && !isVideoGoingToStream) {
        /*
            - if local user video already started and his/her video stop then remove session ID from the video streaming array
        */
        videoStreamingUsersArray = videoStreamingUsersArray.filter((userSessionId) => userSessionId !== updateEventUserSessionID);
    }

    if (isScreenShareGoingToStream && !hasOverwrittenStream) {
        // check update event user's track is screenshare true
        const result = handleScreenSharingOverrides(updateEventUserSessionID, videoStreamingUsersArray, screenSharingUsersArray, isCurrentUserLocal);
        videoStreamingUsersArray = result.videoStreamingUsersArray; // set updated user's video streaming array
        screenSharingUsersArray = result.screenSharingUsersArray; // set updated user's screenshare streaming array
    } else if (screenSharingUsersArray.includes(updateEventUserSessionID) && !isScreenShareGoingToStream) {
        /*
            - if local user screenshare already started and his/her screenshare stop then remove session ID from the screenshare streaming array
        */
        screenSharingUsersArray = screenSharingUsersArray.filter((userSessionId) => userSessionId !== updateEventUserSessionID);
    }

    updateReduxState(screenSharingUsersArray, videoStreamingUsersArray); // set streaming details for video and screenshare
};

// _____________________________________________________
const setVideoScreenShareInGrid = (updateEventUserSessionID, isVideoGoingToStream, isScreenShareGoingToStream) => {
    const participantDetails = {
        identity: updateEventUserSessionID,
        isVideoStreaming: isVideoGoingToStream, // or false
        isScreenShareStreaming: isScreenShareGoingToStream,
        device_type: getUserDetailsById(updateEventUserSessionID)?.device_type || null,
    };
    console.log("setGalleryViewConnectedUser_setVideoScreenShareInGrid", participantDetails);

    // Call the function to update or add the participant
    updateOrAddParticipant(participantDetails);
};

export const updateOrAddParticipant = (participant, removeParticipant, fromConnect) => {
    const { galleryViewConnectedUser } = reduxStore.getState().galleryView;
    if (removeParticipant) {
        const updatedGalleryViewConnectedUser = galleryViewConnectedUser?.filter((value) => value.identity !== participant.identity);
        reduxStore.dispatch(setGalleryViewConnectedUser(updatedGalleryViewConnectedUser));
        return;
    }
    // Create a deep clone of the current array
    const cloneArray = cloneDeep(galleryViewConnectedUser);

    let participantExists = false;

    // Update participant if they exist
    const updatedParticipants = cloneArray.map((user) => {
        if (user.identity === participant.identity && !fromConnect) {
            participantExists = true;
            // Merge existing user data with participant data
            return { ...user, ...participant };
        }
        return user;
    });

    // Add new participant if not found
    if (!participantExists) {
        updatedParticipants.push(participant);
    }

    reduxStore.dispatch(setGalleryViewConnectedUser(updatedParticipants));
};
